import { render, staticRenderFns } from "./CorssTable.vue?vue&type=template&id=55361240&"
import script from "./CorssTable.vue?vue&type=script&lang=js&"
export * from "./CorssTable.vue?vue&type=script&lang=js&"
import style0 from "./CorssTable.vue?vue&type=style&index=0&id=55361240&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports